export enum Pack {
  PACK_1 = 'PACK_1_WITHOUT',
  PACK_2 = 'PACK_2_SINGLE',
  PACK_3 = 'PACK_3_DOUBLE',
  PACK_4 = 'PACK_4_SINGLE',
  PACK_5 = 'PACK_5_DOUBLE',
  PACK_SUPP = 'PACK_SUPP',
}

export const PACKS = [
  {
    id: Pack.PACK_SUPP,
    label: 'Chambre partagée',
    pack: 'Supplément Twin',
    nights: 0,
    price: 2800,
  },
  {
    id: Pack.PACK_1,
    label: 'Sans hébergement',
    pack: 'PACK 1',
    nights: 0,
    price: 2000,
  },
  {
    id: Pack.PACK_2,
    pack: 'PACK 2',
    label: 'Single',
    nights: 2,
    price: 5200,
  },
  {
    id: Pack.PACK_3,
    pack: 'PACK 3',
    label: 'Double',
    nights: 2,
    price: 6900,
  },
  {
    id: Pack.PACK_4,
    pack: 'PACK 4',
    label: 'Single',
    nights: 3,
    price: 6700,
  },
  {
    id: Pack.PACK_5,
    pack: 'PACK 5',
    label: 'Double',
    nights: 3,
    price: 8500,
  },
];
